import styled from '@emotion/styled';
import { getPlusIconBrightnessContrastColors } from './brightnessContrastColors';

export const StyledContainer = styled.div`
	height: 1px;
	width: 100%;
	max-width: 650px;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	z-index: 50;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const StyledPlus = styled.div`
	z-index: 30;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	gap: 10px;
	border-radius: 8px;
	cursor: pointer;
	backdrop-filter: blur(4px);
	${getPlusIconBrightnessContrastColors}
`;
